export const queryKeys = {
  ANALYTIC_RATIO: 'ANALYTIC_RATIO',
  ANALYTIC_COUNT_OWN_OTHER: 'ANALYTIC_COUNT_OWN_OTHER',
  ANALYTIC_COUNT_CONTRACT_LEAD: 'ANALYTIC_COUNT_CONTRACT_LEAD',
  ANALYTIC_BY_EMPLOYEE: 'ANALYTIC_BY_EMPLOYEE'
};
